import { ItemOptions, ItemOptionType } from '../api';

export const uuid = (value) =>
  value
    .toString()
    .match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);

export const salsifyId = (value) =>
  value.toString().match(/^GROUPING-/i) || value.toString().match(/^BUNDLE-\d/i);

export const stringHashCode = (value) => {
  let hash = 0;
  if (typeof value !== 'string') return hash;
  if (value.trim().length === 0) return hash;

  for (let i = 0; i < value.length; i++) {
    const char = value.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash;
  }
  return hash;
};

export const buildItemIdentifier = (
  variantId: number,
  options: Partial<ItemOptions> | undefined,
  bundleExternalId?: string,
): number => {
  const identifier = [bundleExternalId, variantId].filter(Boolean).join(':');
  let giftCardIdentifier;
  switch (options?.type) {
    case ItemOptionType.Engraving:
      return stringHashCode(
        `${identifier}:${options.line1 ?? ''}:${options.line2 ?? ''}:${options.line3 ?? ''}:${
          options.line4 ?? ''
        }`,
      );
    case ItemOptionType.GiftCard:
      giftCardIdentifier = [identifier, ...(options.recipients || []), options.sender]
        .filter(Boolean)
        .sort()
        .join(':')
        .toLowerCase();
      return stringHashCode(giftCardIdentifier);
    default:
      return stringHashCode(`${identifier}`);
  }
};

export const hasOnlyGiftCards = (ids: string[]) => ids.every((id) => id.includes('GIFTCARD'));
